<template>
    <div class="sidebar-menu" data-scrollbar>
        <div class="sidebar-menu-inner">
            <app-left-panel-header></app-left-panel-header>
            <app-left-panel-profile></app-left-panel-profile>
            <app-left-panel-profile-active></app-left-panel-profile-active>
            <app-left-panel-courses></app-left-panel-courses>
            <app-left-panel-personal-chats></app-left-panel-personal-chats>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanelHeader from './LeftPanelHeader.vue';
    import LeftPanelProfile from '../../common_components/LeftPanelProfile';
    import LeftPanelProfileActive from '../../common_components/LeftPanelProfileActive.vue';
    import LeftPanelCourses from './LeftPanelCourses.vue';
    import LeftPanelPersonalChats from './LeftPanelPersonalChats.vue';

    export default {
        data: () => ({

        }),
        methods: {
            setTeacherPage(page) {
                this.$store.dispatch('setTeacherPage', page);
                this.$router.push('teacher-cabinet');
            }
        },
        computed: {
            ...mapGetters([

            ]),
        },
        components: {
            appLeftPanelHeader: LeftPanelHeader,
            appLeftPanelProfile: LeftPanelProfile,
            appLeftPanelProfileActive: LeftPanelProfileActive,
            appLeftPanelCourses: LeftPanelCourses,
            appLeftPanelPersonalChats: LeftPanelPersonalChats,
        },
    }
</script>
